import Tooltip from "rc-tooltip";
import React from "react";

export default function TooltipOverlay(props) {
    return props.overlay ? (
        <Tooltip placement="bottom" overlay={props.overlay}>
            {props.children}
        </Tooltip>
    ) : (
        props.children
    );
}
